import RefNavbar from './RefNavbar';
import RefFeatures from './RefFeatures';

function Page2026Feature() {
  return (
    <>
      <RefNavbar />
      <RefFeatures />
    </>
  );
}

export default Page2026Feature;
